import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { RecordId } from '../../types';
import { RECORD_TOKEN_KEY } from '../../constants';
import { ApiRecord } from '../entities/api-record';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ApiService {

  constructor(private http: HttpClient) {
  }

  getRecord(id: RecordId): Observable<ApiRecord> {
    return this.http.get(this.getRecordUrl(id), this.getOptions())
      .map(response => new ApiRecord(response as any));
  }

  deleteRecord(id: RecordId): Observable<any> {
    return this.http.delete(this.getRecordUrl(id), this.getOptions());
  }

  private getRecordUrl(id: RecordId): string {
    return `${environment.apiUrl}records/${id}`;
  }

  private getOptions(): Object {
    const token = localStorage.getItem(RECORD_TOKEN_KEY);
    const headers = new HttpHeaders({token});

    return {headers};
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/api.service.ts